import { Notification } from '@progress/kendo-popups-vue-wrapper';
import localeEn from '../../../../locales/en'
import localeAr from '../../../../locales/ar'

localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ? import('../../layouts/components/header/theme/header.scss') : import('../../layouts/components/header/theme/header-rtl.scss');

export default {
    name: 'notification-component',
    data() {
        return {            
            NotificationDate: [],
            EnglishLang: localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en',
        }
    },
    mounted() {
        this.notification = this.$refs.notification.kendoWidget();          
    },
    computed: {
        //toaster template
        templateToasterFn() {            
            let templates = [{
                type: "info",
                template: (item) => { 
                    return `<div class="notification-modal" style=${this.EnglishLang ? `"border-left: 9px solid ${item.color}!important;"` : `"border-right: 9px solid ${item.color} !important;"`}>
                                 <div class="notification-body d-flex flex-column flex-fill mr-2">
                                    <div class="d-flex notification-header ml-2 mt-2 mb-1">
                                        <img class="notification-icon mr-2" src="${item.Imgage}" />
                                        <h3 class="notification-title mb-0" style="color:${item.color}">${item.title}</h3>
                                    </div>
                                    <div class="notification-content ml-2 mb-2">
                                        <p class="notification-message mb-0">${item.message}</p>
                                    </div>
                                    <div class="notification-footer d-flex ml-2 mb-2">   
                                    </div>
                                 </div>
                                 <div class="notification-close-icon">
                                    <div class="k-icon k-i-close"></div>
                                 </div>
                            </div>`
                }
            }]
            return templates;
        },
       //hide toaster 
        HideNotificationToaster() {
            //Duration in Seconds * 1000 Milliseconds
            return this.NotificationDate.Duration * 1000;
        }
    },
    methods: {
        //notification show function
       showNotification(data) {
            this.NotificationDate = data

            this.$nextTick(() => {
                this.play();
                this.notification.show({
                    title: this.NotificationDate.Title,
                    message: this.NotificationDate.Message,
                    color: this.NotificationDate.Color,
                    Imgage: this.NotificationDate.IconURL,

                });
            });
        },
        //notification sound 
         play() {
             var audio = new Audio(this.NotificationDate.AlertSoundURL);
             audio.play();
            }
    },
    components: {
        'kendo-notification': Notification
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    },
}
